export const layout = {
  dashBoard: 'Home',
  employees: 'Employees',
  employeesList: 'Personal data registration/editing',
  idCards: 'Id Cards',
  terminals: 'Terminals',
  uniforms: 'Uniforms',
  attendanceLogs: 'Matching data',
  languages: 'Languages',
  announcements: 'Messages',
  admins: 'Admins',
  settings: 'Settings',
  exportHistory: 'Export history',
  logOut: 'Log out',
  clientDevice: 'Client Device',
  clientDeviceByDay: 'View by Day',
  clientDeviceByRangeDay: 'View by Range Day',
  totalClientDeviceByRangeDay: 'View total by Range Day',
  attendanceEmployee: 'Individual productivity management',
  attendanceEmployeeByDay: 'View by Range Day',
  attendanceEmployeeByRangeDay: 'View by Range Day',
  attendanceTotalEmployeeByRangeDay: 'View total by Range Day',
  attendance: 'Data correction, error checking',
  configTime: 'Config time work',
  clientList: 'Client list',
  incident: 'Incident',
  deviceListError: 'List Device Error',
  actionAdmin: 'History change action',
  laundry: 'Laundry',
  operator: 'Operator',
  customer: 'Customer',
  machine: 'Machine',
  machinePart: 'Machine Part',
  detergent: 'Detergent',
  washingMethod: 'Washing Method',
  washingCount: 'Washing Count',
  notification: 'Notification',
  washingHistory: 'Washing History',
  washingMachinePart: 'Washing Machine Part',
  tank: 'Tank',
}
